export let products = [
  {
    "question_id": "cym-crush-1",
    "product_id": 0,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_01.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 1,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_02.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 2,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_03.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 3,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_04.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 4,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_05.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 5,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_06.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 6,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_07.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 7,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_08.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 8,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_09.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 9,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_10.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 11,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_12.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 12,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_13.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 13,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_14.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 14,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_15.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 15,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_16.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 16,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_17.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 17,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_18.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 18,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_19.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 19,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_20.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 20,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_21.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 21,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_22.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 22,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_23.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 23,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_24.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 24,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_25.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 25,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_26.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 26,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_27.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 27,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_28.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 28,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_29.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 29,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_30.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 31,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_32.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 32,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_33.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 33,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_34.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 34,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_35.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 35,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_36.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 36,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_37.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 37,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_38.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "cym-crush-1",
    "product_id": 38,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/CYMBELINE/During/Cymbeline_39.jpg",
    "product_adjust": 0
  },
// VESTAL
  {
    "question_id": "ve-cru-1",
    "product_id": 99991,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/VESTAL/CRUSH/ve_ha_imag_2.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "ve-cru-1",
    "product_id": 99992,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/VESTAL/CRUSH/ve_ha_imag_6.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "ve-cru-1",
    "product_id": 99993,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/VESTAL/CRUSH/ve_ha_imag_10.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "ve-cru-1",
    "product_id": 99994,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/VESTAL/CRUSH/ve_ha_imag_11.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "ve-cru-1",
    "product_id": 99995,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/VESTAL/CRUSH/ve_ha_imag_13.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "ve-cru-1",
    "product_id": 99996,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/VESTAL/CRUSH/ve_ha_imag_14.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "ve-cru-1",
    "product_id": 99997,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/VESTAL/CRUSH/ve_ha_imag_16.jpg",
    "product_adjust": 0
  },
  {
    "question_id": "ve-cru-1",
    "product_id": 99998,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/VESTAL/CRUSH/ve_ha_imag_17.jpg",
    "product_adjust": 0
  },
  //Olga Macia
  {
    "brand_id": 466,
    "question_id": "OM-crush-1",
    "product_id": 66661,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_01.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-crush-1",
    "product_id": 66662,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_02.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-crush-1",
    "product_id": 66663,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_03.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-crush-1",
    "product_id": 66664,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_04.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-crush-1",
    "product_id": 66665,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_05.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-crush-1",
    "product_id": 66666,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_06.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-TOAO1",
    "product_id": 66661,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_01.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-TOAO1",
    "product_id": 66662,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_02.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-TOAO2",
    "product_id": 66663,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_03.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-TOAO3",
    "product_id": 66664,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_04.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-TOAO4",
    "product_id": 66665,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_05.jpg",
    "product_adjust": 0
  },
  {
    "brand_id": 466,
    "question_id": "OM-TOAO5",
    "product_id": 66666,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/OLGA%20MACIA/OlgaMacia_06.jpg",
    "product_adjust": 0
  },
  // LORENA PANEA
  {
    "brand_id": 202,
    "question_id": "LP-crush-1",
    "product_id": 7771,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_01.jpg",
    "product_adjust": 1142
  },
  {
    "brand_id": 202,
    "question_id": "LP-crush-1",
    "product_id": 7772,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_02.jpg",
    "product_adjust": 1138
  },
  {
    "brand_id": 202,
    "question_id": "LP-crush-1",
    "product_id": 7773,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_03.jpg",
    "product_adjust": 1135
  },
  {
    "brand_id": 202,
    "question_id": "LP-crush-1",
    "product_id": 7774,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_04.jpg",
    "product_adjust": 1131
  },
  {
    "brand_id": 202,
    "question_id": "LP-crush-1",
    "product_id": 7775,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_05.jpg",
    "product_adjust": 1120
  },
  {
    "brand_id": 202,
    "question_id": "LP-crush-1",
    "product_id": 7776,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_06.jpg",
    "product_adjust": 1123
  },
  {
    "brand_id": 202,
    "question_id": "LP-crush-1",
    "product_id": 7777,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_07.jpg",
    "product_adjust": 307
  },
  {
    "brand_id": 202,
    "question_id": "LP-TOAO-1",
    "product_id": 7771,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_01.jpg",
    "product_adjust": 1142
  },
  {
    "brand_id": 202,
    "question_id": "LP-TOAO-1",
    "product_id": 7772,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_02.jpg",
    "product_adjust": 1138
  },
  {
    "brand_id": 202,
    "question_id": "LP-TOAO-1",
    "product_id": 7773,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_03.jpg",
    "product_adjust": 1135
  },
  {
    "brand_id": 202,
    "question_id": "LP-TOAO-1",
    "product_id": 7774,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_04.jpg",
    "product_adjust": 1131
  },
  {
    "brand_id": 202,
    "question_id": "LP-TOAO-1",
    "product_id": 7775,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_05.jpg",
    "product_adjust": 1120
  },
  {
    "brand_id": 202,
    "question_id": "LP-TOAO-1",
    "product_id": 7776,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_06.jpg",
    "product_adjust": 1123
  },
  {
    "brand_id": 202,
    "question_id": "LP-TOAO-1",
    "product_id": 7777,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/LORENA%20PANEA/LorenaPanea_07.jpg",
    "product_adjust": 307
  },
  /*** ***/
  {
    "brand_id": 536,
    "question_id": "jp-crush-1",
    "product_id": 2575,
    "image_url": "https://bridal-assets.s3.amazonaws.com/documents/kalliope/medias/JESUS%20PEIRO/DURING/JesusPeiro_02.jpg",
    "product_adjust": 2574
  }

]